import confetti from "canvas-confetti";

const BECKY_COLORS = [
  "#F5CE6F", // gold
  "#E5B24A", // deep gold
  "#D6396C", // fuchsia
  "#9B4A6B", // mauve
  "#F5D6E3", // soft rose
  "#7A4A6B", // mauve deep
];

/**
 * Fires a 2-burst confetti in Beckyliss brand colors. Respects the
 * user's reduced-motion preference (no-op) and is safe to call while
 * a modal is opening — canvas is created at z-index 9999 on top.
 */
export function celebrate({ scalar = 1, spread = 90, particleCount = 90 } = {}) {
  const reduced =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) return;

  const defaults = {
    origin: { y: 0.68 },
    colors: BECKY_COLORS,
    scalar,
    ticks: 220,
    disableForReducedMotion: true,
    zIndex: 9999,
  };

  confetti({ ...defaults, particleCount, spread, angle: 60, origin: { x: 0.1, y: 0.75 } });
  confetti({ ...defaults, particleCount, spread, angle: 120, origin: { x: 0.9, y: 0.75 } });
  setTimeout(() => {
    confetti({ ...defaults, particleCount: 40, spread: 130, startVelocity: 25 });
  }, 260);
}

export default celebrate;
